import { UserDB } from '@/enitites/user'
import { QueryFunctionContext } from '@tanstack/vue-query'
import { userKeys } from '@/enitites/user/api/keys'
import { api } from '@/plugins/axios'

export const getPublicUsers = async ({
  pageParam = 0,
  queryKey,
  signal,
}: QueryFunctionContext<ReturnType<typeof userKeys.list>>) => {
  const [, , params] = queryKey
  const response = await api.get<UserDB[]>('/users', {
    params: {
      p: pageParam,
      pp: params.pageSize,
      orgs: params.orgIds,
      sb: params.sortBy,
      k: params.keyword,
      ex: params.exclude?.filter((e) => Boolean(e)) || [],
    },
    signal,
  })
  return response.data
}

export const getUserById = async ({ queryKey, signal }: QueryFunctionContext<ReturnType<typeof userKeys.detail>>) => {
  const [, , userId] = queryKey
  const response = await api.get<UserDB>(`/user/${userId}`, { signal })
  return response.data
}
